<div *ngIf="!postSign">
    <div class="mb-4">
        <h3>{{ 'sign.driver_title' | translate }}</h3>
        <p class="mb-4">{{ 'sign.description' | translate }}</p>
    </div>
    <div class="mb-4" *ngIf="driverSignerData != undefined">
        <b>{{'sign.driver_data.driver' | translate}}:</b> {{this.driverSignerData.driverName}} <br>
        <b>{{'sign.driver_data.transport_unit' | translate}}:</b> {{this.driverSignerData.transportUnit}} <br>
        <b>{{'sign.driver_data.carrier' | translate}}:</b> {{this.driverSignerData.carrier}} <br>
        <b>{{'sign.driver_data.trip' | translate}}:</b> {{this.driverSignerData.tripNumber}} <br>
        <b>{{'sign.driver_data.destination' | translate}}:</b> {{this.driverSignerData.destination}} <br>
    </div>
</div>

<div *ngIf="postSign">
    <div class="alert alert-primary" role="alert">
        {{'sign.driver_data.post_sign_information' | translate}}
    </div>
</div>
